import { useEffect, useState } from "react";
import axios from "axios";
import { Quote } from "lucide-react";
import { API } from "../lib/api";
import { Stars } from "./Stars";

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/testimonials`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-6 mb-20" data-testid="testimonials-section">
      <div className="text-center mb-10">
        <div className="text-xs uppercase tracking-[0.28em] text-amber-300/80 mb-3">In their words</div>
        <h2 className="font-display text-3xl md:text-4xl text-neutral-100">After the call.</h2>
      </div>
      <div className="flex flex-wrap justify-center gap-6">
        {items.map((t) => (
          <figure key={t.id} className="card-surface p-6 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]" data-testid={`testimonial-${t.id}`}>
            <div className="flex items-center justify-between mb-3">
              <Quote size={18} className="text-amber-300/70" />
              {t.rating && <Stars value={t.rating} size={14} testid={`testimonial-stars-${t.id}`} />}
            </div>
            <blockquote className="text-sm text-neutral-200 leading-relaxed">{t.text}</blockquote>
            <figcaption className="text-xs text-neutral-500 mt-4">— {t.display_name}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
